/**
 * Created by Darius on 2017.04.02.
 */
const defaultState = {
    inProgress: true,
    saving: false,
    errors: null,
    openDeleteDialog: false
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case 'REQUEST_ROLES':
            return {
                ...state,
                inProgress: false,
                roles: action.payload,
                errors: action.error ? action.payload.ExceptionMessage : null
            };
        case 'REQUEST_ROLE':
            return {
                ...state,
                inProgress: false,
                role: action.payload,
                initialValues: action.payload,
                errors: action.error ? action.payload.ExceptionMessage : null
            };
        case 'SUBMIT_ROLE':
            return {
                ...state,
                saving: false,
                role: action.payload,
                initialValues: action.payload,
                errors: action.error ? action.payload.ExceptionMessage : null
            };
        case 'CONFIRM_DELETE_ROLE':
            return {
                ...state,
                openDeleteDialog: action.payload
            };
        case 'DELETE_ROLE':
            return {
                ...state,
                saving: false,
                openDeleteDialog: action.error ? true : false,
                errors: action.error ? action.payload.ExceptionMessage : null
            };
        case 'ROLES_PAGE_UNLOADED':
            return {...defaultState};
        case 'ASYNC_START':
            if (action.subtype === 'REQUEST_ROLES'
                || action.subtype === 'REQUEST_ROLE') {
                return { ...state, inProgress: true };
            } else if (action.subtype === 'DELETE_ROLE'
                || action.subtype === 'SUBMIT_ROLE') {
                return { ...state, saving: true };
            }
            break;
    }

    return state;
};